export const buildErrorMessageFromDataApiResponse = async (
    currentErrorMessage: string,
    error: Response,
): Promise<string> => {
    let body
    try {
        // This could respond with html instead of json
        body = await error.json()
    } catch (jsonError) {
        console.warn(jsonError)
    }
    if (body?.detail) {
        currentErrorMessage = `${currentErrorMessage} ${body.detail}`
    } else if (body?.error?.message) {
        currentErrorMessage = `${body.error.message}`
    } else if (error.statusText) {
        currentErrorMessage = `${currentErrorMessage} ${error.statusText}`
    }
    return currentErrorMessage
}
